<script lang="ts">
import type { DisplayBlockProps } from '#layers/blocks/types/display-block';
import type { ColorPreset } from '#layers/ui/public';

/** Repeater display items can contain incomplete or explicitly cleared preset fields. */
type ColorPresetItem = { [Key in keyof ColorPreset]?: ColorPreset[Key] | null };

export interface DisplayColorPresetProps extends DisplayBlockProps<string | null, ColorPresetItem> {}

const __DsBlock = {
	name: '$t:blocks.display_color_value.name',
	description: '$t:blocks.display_color_value.description',
	category: 'display',
	hidden: true,
}</script>

<script setup lang="ts">
import { computed } from 'vue';
import { defineBlock } from '#layers/block-engine/public';
import { useTranslationUtils } from '#layers/i18n/public';

const props = defineProps<DisplayColorPresetProps>();

;

const resolvedValue = computed(() => props.item?.value ?? props.value);
const { translateString } = useTranslationUtils();
const resolvedLabel = computed(() => translateString(props.item?.label ?? resolvedValue.value ?? undefined));
const resolvedColor = computed(() => {
	const color = props.item?.color ?? resolvedValue.value;
	return color;
});
const tooltip = computed(() => translateString(props.item?.tooltip ?? resolvedValue.value ?? undefined));
</script>

<template>
	<DDisplayValueEmpty v-if="!resolvedValue" />
	<DTooltip v-else :text="tooltip">
		<div class="inline-flex min-w-0 items-center gap-2">
			<DColorDot v-if="resolvedColor" :color="resolvedColor" size="sm" />
			<span class="truncate text-sm">{{ resolvedLabel }}</span>
		</div>
	</DTooltip>
</template>
